export default __webpack_public_path__ + "static/media/logo_full.cdea9fdf.png";